import { defineAsyncComponent } from 'vue'

export enum VocusNBNRouteName {
    Index = 'vocus-nbn.index',
    SettingsIndex = 'vocus-nbn.settings.index',
    SettingsFormSchema = 'vocus-nbn.settings.form-schema',
    ServerShow = 'vocus-nbn.server.show',
    ServerServicesIndex = 'vocus-nbn.server.services.index',
    ServerServicesCreate = 'vocus-nbn.server.services.create',
    ServerServicesDetails = 'vocus-nbn.server.services.details',
    ServerServicesTestDetails = 'vocus-nbn.server.service.details.test-details',
    ServerInvoicesIndex = 'vocus-nbn.server.invoices.index',
    ServerServiceQualify = 'vocus-nbn.server.services.service-qualify',
    ServerServicesUpdateAppointmentDate = 'vocus-nbn.server.services.update-appointment-date',
    ServerServicesUpdateAppointmentContact = 'vocus-nbn.server.services.update-appointment-contact',
    ServerServicesUpdateAppointment = 'vocus-nbn.server.services.update-appointment',
}

export default {
    routes: [
        {
            path: '/vocus-nbn',
            name: VocusNBNRouteName.Index,
            component: () => import('./views/Index.vue'),
            meta: {
                label: 'Vocus NBN',
                icon: 'fal fa-envelope-open-text fa-fw',
                permission: 'manage-vocus',
                menuItem: defineAsyncComponent(() => import('./components/MenuItem.vue')),
                auth: true,
                module: 'metatech/vocus-nbn',
            },
            children: [
                {
                    path: 'settings',
                    name: VocusNBNRouteName.SettingsIndex,
                    component: () => import('./views/settings/Index.vue'),
                    meta: {
                        label: 'Settings',
                        permission: 'manage-vocus',
                    },
                    children: [
                        {
                            path: 'form-schema',
                            name: VocusNBNRouteName.SettingsFormSchema,
                            component: () => import('./views/settings/form-schema/Index.vue'),
                            meta: {
                                label: 'Form Schema',
                                permission: 'manage-vocus',
                            },
                            children: [],
                        },
                    ],
                },
                {
                    path: 'servers/:serverId',
                    name: VocusNBNRouteName.ServerShow,
                    component: () => import('./views/server/Show.vue'),
                    meta: {
                        label: 'Server',
                        permission: 'manage-vocus',
                    },
                    children: [
                        {
                            path: 'services',
                            name: VocusNBNRouteName.ServerServicesIndex,
                            component: () => import('./views/server/service/Index.vue'),
                            meta: {
                                label: 'Services',
                                icon: 'gears',
                                permission: 'manage-vocus',
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: VocusNBNRouteName.ServerServicesCreate,
                                    component: () => import('./views/server/service/Index.vue'),
                                    meta: {
                                        label: 'Create',
                                        icon: 'fal fa-cabinet-filing fa-fw',
                                        permission: 'manage-vocus',
                                    },
                                },
                                {
                                    path: ':serviceId/details',
                                    name: VocusNBNRouteName.ServerServicesDetails,
                                    component: () => import('./views/server/service/Index.vue'),
                                    meta: {
                                        label: 'Details',
                                        icon: 'fal fa-cabinet-filing fa-fw',
                                        permission: 'manage-vocus',
                                    },
                                    children: [
                                        {
                                            path: ':testId/test-details',
                                            name: VocusNBNRouteName.ServerServicesTestDetails,
                                            component: () =>
                                                import('./views/server/service/Index.vue'),
                                            meta: {
                                                label: 'Test Details',
                                                icon: 'fal fa-cabinet-filing fa-fw',
                                                permission: 'manage-vocus',
                                            },
                                        },
                                    ],
                                },
                                {
                                    path: ':serviceId/update-appointment-date',
                                    name: VocusNBNRouteName.ServerServicesUpdateAppointmentDate,
                                    component: () => import('./views/server/service/Index.vue'),
                                    meta: {
                                        label: 'Update Appointment Date',
                                        icon: 'fal fa-cabinet-filing fa-fw',
                                        permission: 'manage-vocus',
                                    },
                                },
                                {
                                    path: ':serviceId/update-appointment-contact',
                                    name: VocusNBNRouteName.ServerServicesUpdateAppointmentContact,
                                    component: () => import('./views/server/service/Index.vue'),
                                    meta: {
                                        label: 'Update Appointment-contact',
                                        icon: 'fal fa-cabinet-filing fa-fw',
                                        permission: 'manage-vocus',
                                    },
                                },
                            ],
                        },
                        {
                            path: 'invoices',
                            name: VocusNBNRouteName.ServerInvoicesIndex,
                            component: () => import('./views/server/invoice/Index.vue'),
                            meta: {
                                label: 'Invoices',
                                icon: 'file-invoice',
                                permission: 'manage-vocus',
                            },
                        },
                        {
                            path: 'service-qualify',
                            name: VocusNBNRouteName.ServerServiceQualify,
                            component: () => import('./views/server/service/Index.vue'),
                            meta: {
                                label: 'Service Qualify',
                                icon: 'file-magnifying-glass',
                                permission: 'manage-vocus',
                            },
                        },
                    ],
                },
            ],
        },
    ],
}
